import React from "react";
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import ReactStars from 'react-stars';
import moment from 'moment';
import Textarea from 'react-textarea-autosize';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/stackslide.css';
import defaultImage from '../../images/video_not_found.png';

import { getDateTime, UTCToLocal } from "../../helper";
import {
    quitFromOrder,
    updateOrderRequest,
    updateOrderReceive,
    responseOrder,
    getExecutors,
    requestResponseOrderByID,
    receiveResponseOrderByID,
} from '../../actions/orderActions';

import $ from "jquery";
window.jQuery = $;
require("@fancyapps/fancybox")

/*global google*/

class MakeOrderDatePriceInfo extends React.Component {

    constructor() {
        super();

        this.state = {
            toggle: true,

            showMenu: false,

            generalShow: false,
            objectShow: false,
            biddingShow: false,
            contractorShow: false,
            detailsShow: false,

            objectIds: {},
            allExamples: {},

            isMap: false,
            mapInit: false,
        }

        this.showMenu = this.showMenu.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
    }

    showMenu(event) {
        event.preventDefault();
        
        this.setState({ showMenu: true }, () => {
            document.addEventListener('click', this.closeMenu);
        });
    }
    
    closeMenu(event) {
        if (!this.dropdownMenu.contains(event.target)) {
            
            this.setState({ showMenu: false }, () => {
                document.removeEventListener('click', this.closeMenu);
            });
        }
    }

    sectionToggle(section) {
        this.setState({
            [section]: !this.state[section]
        })
    }

    getDatePreview(order) {
        const {address_text, order_date_at, order_date_end_at, order_time_at, order_time_end_at, is_test} = order;
        let text = (address_text && address_text.trim().length) && address_text || 'Место съемки не выбрано';

        let dateText = 'Дата не указана';
        let timeText = 'Не указана';

        let startDateTime = getDateTime(new Date(order_date_at), order_time_at);
        let endDateTime = getDateTime(new Date(order_date_end_at?order_date_end_at:order_date_at), order_time_end_at);

        let startDateTimeLocal = UTCToLocal(startDateTime.dateTime);
        let endDateTimeLocal = UTCToLocal(endDateTime.dateTime);

         if(startDateTime.isDate) {
             let date = moment(startDateTimeLocal, "DD/MM/YYYY");
             let dateNum = moment().startOf("day").diff(date, "days");
             dateText = order_date_at;
             if(dateNum === 0) dateText = 'Сегодня';
             if(dateNum === -1) dateText = 'Завтра';
             if(dateNum === -2) dateText = 'Послезавтра';
         }

        timeText = (startDateTimeLocal.isValid()) ? ', С ' + startDateTimeLocal.format("HH:mm") : '';
        timeText += (endDateTimeLocal.isValid()) ? ' До ' + endDateTimeLocal.format("HH:mm") : '';

        if(!startDateTime.isDate && !endDateTime.isDate && !startDateTime.isTime && !endDateTime.isTime){
            timeText = '';
            dateText = 'Дата и время не указана';
        }

        if(is_test) {
            return 'Тестовый заказ не имеет время исполнения, заказчика, и цены.';
        }

        return text + ", " + dateText + timeText;
    }

    getObjectPreview(currentObject) {
        if(!currentObject) return 'Объект не выбран';

        let order_object = Object.assign({}, currentObject.order_object);
        let order_method = Object.assign({}, currentObject.order_method);
        let method_type = Object.assign({}, order_method.method_type);

        let shooting = method_type.is_video ? currentObject.video_mins_ordered + ' мин. видео' : currentObject.photos_ordered + ' фото';
        let text = [];
        
        if(order_object.title){
            text.push(order_object.title);
        }
        else text.push("Объект не выбран");
        text.push(shooting);

        if(order_method.title){
            text.push(order_method.title);
        }

        text.push("примечание к объекту: " + (currentObject.content || 'нет примечания'));

        return text.join(", ");
    }

    getContractorPreview(order) {
        const {contractor_count, order_allow_upload_max_radius, contractor_minimal_rating} = order;
        const {currentCamera} = this.props;

        let contractor = contractor_count > 0 ? contractor_count + ' человек' : 'не указан';
        let camera = (currentCamera && currentCamera.title) ? currentCamera.title : 'не выбран';
        let radius = order_allow_upload_max_radius > 0 ? order_allow_upload_max_radius + ' метров' : 'не указан';
        let rating = (contractor_minimal_rating > 0) ? contractor_minimal_rating : 'нет требований';
        return 'Исполнителей - ' + contractor + ', Аппарат - ' + camera + ', Допустимы радиус - ' + radius + ', Класс исполнителя - ' + rating;
    }

    getBidsPreview(order) {
        const {is_auction} = order;
        let start = is_auction ? 'Торги, ' : 'Без торгов, ';
        let text2 = '';
        let text3 = '';

        if(!order) return start;

        let date = this.getContractorTime(order);

        text2 = `Исполнитель должен быть назначен ${moment(date.start.dateTime).format("DD.MM.YYYY")} числа в ${moment(date.start.dateTime).format("HH")} часов ${moment(date.start.dateTime).format("mm")} минут`                                             
    
        text3 =  date.end.isTime ?
            `Результаты выполнения должны быть ${moment(date.end.dateTime).format("DD.MM.YYYY")} до ${moment(date.end.dateTime).format("HH")} часов ${moment(date.end.dateTime).format("mm")} минут`
            : `Результаты выполнения должны быть до, время не указано.`;

        return start + " " + text2 + ", " + text3;
    }

    getDetailInfoPreview(order) {
        const {user, is_public, allow_upload_results_from_web} = order;

        if(!user) return '';

        const userinfo = `Заказчик: ${user.first_name} ${user.last_name}`;
        const publicText = is_public ? ', Общедоступный заказ' : '';
        const from_web = allow_upload_results_from_web ? 'Можно загрузить результаты с компьютера' : 'Результаты загружаются с мобильного приложения';

        let info = [userinfo, from_web].join(', ');

        return `${info}${publicText}`;
    }

    handleMap(e, order) {
        e.preventDefault();
        this.setState({
            isMap: !this.state.isMap
        }, () => {
            if (this.state.isMap && !this.state.mapInit) this.initMap(order);
        });
    }

    initMap(order) {
        var bounds = new google.maps.LatLngBounds();
        const { address_text, address_latitude, address_longitude } = order;

        if(!address_latitude || !address_longitude) return false;

        let center = new google.maps.LatLng(address_latitude, address_longitude);

        let map = new google.maps.Map(this.refs.map, {
            center,
            zoom: 15,
            scrollwheel: true,
        });

        let position = new google.maps.LatLng(
            address_latitude || 0,
            address_longitude || 0
        )
        let pin = new google.maps.Marker({
            position,
            map: map,
            zIndex: 2,
            optimized: false
        });

        bounds.extend(pin.getPosition());
    }

    handleResponseOrder(id) {
        if(!id) return false;

        const { dispatch } = this.props;

        dispatch(responseOrder(id, () => {
            dispatch(requestResponseOrderByID());
            setTimeout(() => {
                dispatch(receiveResponseOrderByID(id));
                dispatch(getExecutors(id));
            }, 10);
        }));
    }

    getStartAuctionTime(order) {
        //1) В заказе перед должно быть видно время, когда начнутся торги
        //(начало исполнения минус время за которое начнутся торги,
        //но не ранее текущего времени)
        const {
            order_date_at,
            order_time_at,
            auction_set_contractor,
            is_auction,
            auction_time,
        } = order;

        let startDateTime = getDateTime(new Date(order_date_at), order_time_at);
        let startDateTimeLocal = UTCToLocal(startDateTime.dateTime);

        if(!is_auction){
            return {
                start: {
                    ...startDateTime,
                    dateTime: moment(startDateTimeLocal, "DD.MM.YYYY HH:mm")
                }
            };
        }

        let auctionFinish = new Date(moment(startDateTime.dateTime).format("MM/DD/YYYY HH:mm"));
        auctionFinish.setMinutes(auctionFinish.getMinutes() - auction_set_contractor || 0);

        let auctionStart = new Date(moment(auctionFinish).format("MM/DD/YYYY HH:mm"));
        auctionStart.setMinutes(auctionStart.getMinutes() - auction_time || 0);
        // let dDateStart = new Date(moment(startDateTimeLocal).format("MM/DD/YYYY HH:mm"));
        // dDateStart.setMinutes(dDateStart.getMinutes() - auction_time || 0);
        
        return {
            start: {
                ...startDateTime,
                dateTime: moment(auctionStart, "DD.MM.YYYY HH:mm")
            }
        }
    }

    getContractorTime(order) {
        //2) В заказе должно быть видно время, когда должен быть
        //назначен исполнитель
        //(время исполнения минус время за которое назначается исполнитель)
        const {
            order_date_at,
            order_date_end_at,
            order_time_at,
            order_time_end_at,
            auction_set_contractor,
        } = order;

        let startDateTime = getDateTime(new Date(order_date_at), order_time_at);
        let endDateTime = getDateTime(new Date(order_date_end_at?order_date_end_at:order_date_at), order_time_end_at);

        let startDateTimeLocal = UTCToLocal(startDateTime.dateTime);
        let endDateTimeLocal = UTCToLocal(endDateTime.dateTime);

        let fDateStart = new Date(moment(startDateTimeLocal).format("MM/DD/YYYY HH:mm"));
        fDateStart.setMinutes(fDateStart.getMinutes() - auction_set_contractor || 0);

        return {
            start: {
                ...startDateTime,
                dateTime: moment(fDateStart, "DD.MM.YYYY HH:mm")
            },
            end: {...endDateTime, dateTime: endDateTimeLocal},
        }
    }

    textTips1(order) {
        let date = this.getStartAuctionTime(order);
        return `Торги по заказу начнутся ${moment(date.start.dateTime).format("DD.MM.YYYY")} числа в ${moment(date.start.dateTime).format("HH")} часов ${moment(date.start.dateTime).format("mm")} минут`                                             
    }

    textTips2(order) {
        let date = this.getContractorTime(order);
        return `Исполнитель должен быть назначен ${moment(date.start.dateTime).format("DD.MM.YYYY")} числа в ${moment(date.start.dateTime).format("HH")} часов ${moment(date.start.dateTime).format("mm")} минут`                                             
    }

    textTips3(order) {
        let date = this.getContractorTime(order);

        return  date.end.isTime ?
        `Результаты выполнения должны быть ${moment(date.end.dateTime).format("DD.MM.YYYY")} до ${moment(date.end.dateTime).format("HH")} часов ${moment(date.end.dateTime).format("mm")} минут`
        : `Результаты выполнения должны быть до, время не указано.`;                         
    }

    exampleWorkView(example) {
        if(!example) {
            return false;
        }

        let images = example.images || [];
        let videos = example.videos || [];
    
        let results = [
            ...images,
            ...videos
        ];

        if(!results.length) {
            return <div style={{color: '#999'}}>Примеры работ не прикреплены к заказу</div>
        }
    
        return results.map((object, index) => {
            if(object.image) return <img className="examples__image" key={index} src={`${object.image}`} />
            if(object.video) return <video key={index} src={object.video} width="110" height="95" controls="controls"></video>
            return;
        })
    }

    handleQuitFromOrder(e) {
        e.preventDefault();
        const {currentUserID, executors, currentOrder} = this.props;

        if(!executors || !executors.length) return false;

        let currentBid = executors.filter(item => item.user.id === currentUserID);

        if(!currentBid.length) return false;

        this.props.dispatch(
            quitFromOrder(currentBid[0], () => {
                this.props.dispatch(updateOrderRequest());

                let newOrderState = Object.assign({}, currentOrder, {
                    bid_count: currentOrder.bid_count ? currentOrder.bid_count - 1 : 0,
                    is_my_bid: false,
                });

                Alert.success('Вы отказались от выполнения заказа', {
                    position: 'bottom-left',
                    effect: 'stackslide',
                    timeout: 5000
                });

                setTimeout(() => {
                    this.props.dispatch(updateOrderReceive(newOrderState))
                }, 1);
            })
        );
    }

    objectMoreInfoToggle(index) {
        let ids = Object.assign({}, this.state.objectIds);
        if(ids[index]) {
            delete ids[index]
        }
        else{
            ids[index] = index
        }

        this.setState({
            objectIds: ids
        });
    }

    handleAllExample(index) {
        let ids = Object.assign({}, this.state.allExamples);
        if(ids[index]) {
            delete ids[index]
        }
        else{
            ids[index] = index
        }
        this.setState({
            allExamples: ids
        });
    }

    render() {

        let {
            user_id,
            is_auction,
            currentUserID,
            status,
            is_test,
            repeatOrder,
            cancelOrder,
            changePrice,
            is_failed,
            currentCamera,
            editOrder,
            isLoggedIn,
            currentOrder,
        } = this.props;

        const isCustomer = user_id === currentUserID;

        if(!currentOrder) return false;

        let startDate = getDateTime(new Date(currentOrder.order_date_at), currentOrder.order_time_at);
        let endDate = getDateTime(new Date(currentOrder.order_date_end_at?currentOrder.order_date_end_at:currentOrder.order_date_at), currentOrder.order_time_end_at);
        let startDateUTC = UTCToLocal(startDate.dateTime);
        let endDateUTC = UTCToLocal(endDate.dateTime);

        let menuCount = 0;
        let changePriceButton = false;
        let responseButton = false;
        let quitOrderButton = false;
        let cancelOrderButton = false;
        let repeatOrderButton = false;
        let editOrderButton = false;

        if(isLoggedIn && (status === 1 || status === 2) && !isCustomer && currentOrder.is_my_bid) {
            menuCount++;
            quitOrderButton = true;
        }
        if(isLoggedIn && (status === 1 || status === 2) && !isCustomer && !currentOrder.is_my_bid) {
            menuCount++;
            responseButton = true;
        }
        if(isCustomer && status === 2 && is_auction){
            menuCount++;
            changePriceButton = true;
        }
        if(isLoggedIn && status !== 0 && (isCustomer || currentOrder.is_my_bid || currentOrder.is_public)) {
            menuCount++;
            repeatOrderButton = true;
        }
        if(isCustomer && (status >= 1 && status <= 3) && !is_failed) {
            menuCount++;
            editOrderButton = true;
        }
        if((isCustomer && (status >=1 && status <= 4) && !is_failed)) {
            menuCount++;
            cancelOrderButton = true;
        }

        let dateTime1 = ' C ' + 
                        moment.parseZone(currentOrder.local_order_date_time_at).format("DD.MM.YYYY") +
                        ' ' +
                        moment.parseZone(currentOrder.local_order_date_time_at).format("HH:mm") + 
                        ' по ' +
                        moment.parseZone(currentOrder.local_order_date_time_end_at).format("DD.MM.YYYY") +
                        ' ' +
                        moment.parseZone(currentOrder.local_order_date_time_end_at).format("HH:mm");

        let dateTime2 = ' C ' +
                        moment(startDateUTC).format("DD.MM.YYYY") + 
                        ' ' +
                        moment(startDateUTC).format("HH:mm") + 
                        ' по ' +
                        moment(endDateUTC).format("DD.MM.YYYY") +
                        ' ' +
                        moment(endDateUTC).format("HH:mm")

        return (
            
            <div className="create-order-form" style={{paddingTop: '15px', paddingBottom: 0, position:'relative'}}>

                
                    <div className="general-settings general-settings-new-style">
                        <div className="objects-title">
                            <h3 style={{marginBottom:0}}>Место и время</h3>
                        </div>
                        <div className="common create-order-accordion active">

                            <div className="field-wrap" style={{marginBottom:0}}>
                                <input
                                    value={currentOrder.title}
                                    type="text"
                                    className="width100"
                                    readOnly
                                />
                            </div>

                            <div className="input-wrap width100 input-wrap-place" style={{marginBottom:0}}>
                                <div style={{width:'100%', position:'relative'}}>
                                    <input
                                        type="text"
                                        className="width100"
                                        value={currentOrder.address_text}
                                        readOnly
                                    />

                                    <a href="" onClick={(e) => this.handleMap(e, currentOrder)} className="input-right-link create-order__map-marker">
                                        {
                                            this.state.isMap ? 'Закрыть карту' : 'На карте'
                                        }
                                    </a>
                                </div>
                            </div>

                            {
                                this.state.isMap ?
                                    <div className="input-wrap width100 input-wrap-map">
                                        <div ref="map" className="map"></div>
                                    </div>
                                    : ''
                            }

                            <div className="field-wrap width100 input-wrap-place">
                                <input
                                    type="text"
                                    className="width100"
                                    value={currentOrder.address_comment || 'Комментарий не указан'}
                                    readOnly
                                />
                            </div>

                            {
                                currentOrder.is_test ? null :
                                <div className="field-wrap  new-order-time-date" style={{display:'flex', }}>
                                    <div style = {{width: '100%'}}>
                                        <label className="fixInputDate create-order__order-date" style={{zIndex: 22, position:'relative'}}>
                                            <div className="form__label" style={{marginBottom: '-5px'}}>Дата и время съемки (по времени местоположения)</div>
                                                <input
                                                    type="text"
                                                    className="width100"
                                                    style={{paddingLeft:0, border: 0}}
                                                    value={dateTime1}
                                                    readOnly
                                                />
                                        </label>
                                    </div>
                                </div>
                            }

                            {
                                currentOrder.is_test ? null :
                                <div className="field-wrap  new-order-time-date" style={{display:'flex',marginBottom:0}}>
                                    <div style = {{width: '100%'}}>
                                        <label className="fixInputDate create-order__order-date" style={{zIndex: 22, position:'relative'}}>
                                            <div className="form__label" style={{marginBottom: '-5px',fontSize: '13px'}}>Дата и время съемки (по вашему времени)</div>
                                                <input
                                                    type="text"
                                                    className="width100"
                                                    style={{paddingLeft:0, border: 0,fontSize: '13px',marginTop:'-5px'}}
                                                    value={dateTime2}
                                                    readOnly
                                                />
                                        </label>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>


                    {
                        currentOrder.orderposition_set.map((item, index) => {
                            let exampleShootingResults = [...item.images, ...item.videos];
                            let exampleShootingCrop = [...exampleShootingResults];

                            if(exampleShootingCrop.length > 5 && !this.state.allExamples[index+1]) {
                                let images = exampleShootingCrop.slice(Math.max(exampleShootingCrop.length - 5, 1));
                                exampleShootingCrop = [...images];
                            }

                            let isUploadedVideos = item.videos.filter(item => !item.is_converted);

                            return <div key={index} className="objects general-settings-new-style">
                                <div className="create-order__object-action">
                                    <div className="create-order__object-number" style={{fontSize:'20px', color:'#faa83d'}}>{index+1}.</div>
                                </div>
                                <div
                                // onClick={() => this.sectionToggleObject(index)}
                                    className="objects-title"
                                    >
                                    <h3>Что и как снимать</h3>
                                </div>
                                <div className="create-order-accordion active">
                                    <div className="order-object">
                                        <div className="width55 textarea-style-container" style={{
                                                marginBottom:'20px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                minHeight: '25px',
                                                paddingBottom: '4px'
                                            }}>
                                            <Textarea
                                                placeholder="Название объекта"
                                                defaultValue={item.order_object && item.order_object.title}
                                                value={item.order_object && item.order_object.title}
                                                className="width100"
                                                style={{background:'transparent'}}
                                                readOnly
                                            />
                                        </div>

                                        <div className="width35 autocomplete-wrapper" style={{marginBottom:"20px"}}>
                                            {
                                                item.order_method && item.order_method.method_type && item.order_method.method_type.is_video
                                                ?
                                                <div>
                                                    <input
                                                        type="number"
                                                        placeholder="Длительность видео в мин."
                                                        value={item.video_mins_ordered}
                                                        readOnly
                                                    />
                                                    <span className="shooting-count-tag">длина видео (мин.)</span>
                                                </div>
                                                :
                                                <div>
                                                    <input
                                                        type="number"
                                                        placeholder="Количество кадров"
                                                        value={item.photos_ordered}
                                                        readOnly
                                                    />
                                                    <span className="shooting-count-tag">кол. кадров</span>
                                                </div>
                                            }
                                        </div>

                                        <div className={`object__more-info-sp ${this.state.objectIds[index+1]  ? 'active' : ''}`}>
                                            <div style={{width:'100%', marginTop:'15px', marginBottom:'10px'}}>
                                                <a className={`object__more-info-link ${this.state.objectIds[index+1] ? 'active' : ''}`}
                                                    onClick={() => this.objectMoreInfoToggle(index+1)}
                                                    >{this.state.objectIds[index+1]  ? 'Закрыть дополнительные параметры' : 'Дополнительные параметры'}
                                                </a>
                                                <div className="makeorder-section-info object-preview-text">Объекты съемки ({this.getObjectPreview(item)})</div>
                                            </div>

                                            <div className={`object__more-info-inner ${this.state.objectIds[index+1]  ? 'active' : ''}`}>
                                                <div className="width55 autocomplete-wrapper" style={{marginBottom:'30px'}}>
                                                    <input
                                                        type="text"
                                                        style={{width:'100%', cursor:'default'}}
                                                        placeholder="Группа объекта"
                                                        value={item.order_object && item.order_object.order_object_group && item.order_object.order_object_group.title || 'Группы нет'}
                                                        readOnly
                                                    />
                                                </div>
                                                <input
                                                    type="text"
                                                    className="width35"
                                                    style={{cursor:'default'}}
                                                    value={item.order_object.object_type && item.order_object.object_type.title || ''}
                                                    readOnly
                                                />
                                                <input
                                                    type="text"
                                                    className="width35"
                                                    style={{cursor:'default'}}
                                                    value={item.order_method && item.order_method.method_type && item.order_method.method_type.title || ''}
                                                    readOnly
                                                />
                                                <div className="width55 autocomplete-wrapper" style={{marginBottom:'30px'}}>
                                                    <input
                                                        type="text"
                                                        style={{width:'100%', cursor:'default'}}
                                                        placeholder="Метод съемки"
                                                        value={item.order_method && item.order_method.title || ''}
                                                        readOnly
                                                    />
                                                </div>

                                                <div className="width100 textarea-style-container" style={{marginBottom:'30px'}}>
                                                    <Textarea
                                                        value={item.order_method && item.order_method.content || 'Без описания'}
                                                        placeholder="Описание"
                                                        className="width100"
                                                        style={{background:'transparent'}}
                                                        disabled
                                                    />
                                                </div>

                                                <div className="width100 tool-autocomplete" style={{marginBottom:'30px'}}>
                                                    <input
                                                        type="text"
                                                        style={{width:'100%', cursor:'default'}}
                                                        placeholder="Инструмент"
                                                        value={item.order_method && item.order_method.measure && item.order_method.measure.title || 'Без дополнительного инструмента'}
                                                        readOnly
                                                    /> 
                                                </div>
                                            </div>
                                        </div>

                                        <div className="width100 textarea-style-container" style={{
                                                marginBottom:'10px',
                                                marginTop:'20px',
                                                minHeight: '25px',
                                                paddingBottom: '10px'
                                            }}>
                                            <Textarea
                                                placeholder="Уточнение"
                                                className="width100"
                                                defaultValue={item.content || ''}
                                                style={{backgroundColor:'transparent'}}
                                                readOnly
                                            />
                                        </div>


                                        {
                                            exampleShootingResults.length ?
                                            <div className="filming-examples width100" style={{marginTop:'20px'}}>
                                                <div>
                                                    <div style={{flexDirection:'row', display:'flex', alignItems:'center',marginBottom:'25px'}}>
                                                        <h3 style={{width:'auto',flexGrow:1, marginBottom:0,marginTop:0}}>
                                                            Пример съемки 
                                                            {
                                                                exampleShootingResults.length ?
                                                                " " + exampleShootingCrop.length + "/" + exampleShootingResults.length
                                                                : null
                                                            }
                                                        </h3>
                                                        {
                                                            exampleShootingResults.length > 5 ?
                                                            [
                                                                <a key="img2" href="" style={{fontSize:'14px'}} onClick={(e) => {e.preventDefault(); this.handleAllExample(index+1)}}>
                                                                    {this.state.allExamples[index+1] ? 'Скрыть' : 'Показать все'}
                                                                </a>
                                                            ]
                                                            : null
                                                        }
                                                    </div>
                                                    <ul className="examples">
                                                        {
                                                            exampleShootingCrop.map((item, index) => {
                                                                let fileEx = item.type;

                                                                if(item.image && !item.type) fileEx = 'image';
                                                                if(item.video && !item.type) fileEx = 'video';

                                                                if(fileEx !== "image" && fileEx !== "video") return false;
                                                                
                                                                return (<li key={index}>
                                                                        {
                                                                                fileEx === "image" ?
                                                                                <a className="img" href={item.image} data-fancybox>
                                                                                    <img src={item.image} />
                                                                                </a> 
                                                                                :
                                                                                fileEx === 'video' ?
                                                                                    item.is_converted ?
                                                                                    // <a className="mm-video" href={item.video} data-fancybox>
                                                                                    //     <video src={item.video} width="100" height="95" controls="controls"></video>
                                                                                    // </a>
                                                                                    <div style={{height:'95px',width:'100px',position:'relative',zIndex:1}}>
                                                                                        <a href={item.video} data-fancybox className="mm-video">
                                                                                            <i className="play-icon-video"></i>
                                                                                            <img
                                                                                                style={{borderRadius:'20px',width:'100px',height:'95px'}}
                                                                                                src={item.thumb_image}
                                                                                                />
                                                                                        </a>
                                                                                    </div>
                                                                                    :
                                                                                    <a className="img">
                                                                                        <img src={defaultImage} />
                                                                                    </a>
                                                                                : null
                                                                            }
                                                                        </li>)
                                                            })
                                                        }
                                                        
                                                    </ul>

                                                    {
                                                        isUploadedVideos.length ?
                                                        <div style={{padding:'15px', background:'rgb(255, 219, 172)'}}>
                                                            Видео будет доступно для просмотра после загрузки и конвертации на сервере
                                                        </div>
                                                        : null
                                                    }

                                                </div>
                                            </div>
                                            : ''
                                        }
                                    </div>
                                </div>
                            </div>

                        }
                    )}

                    <Alert stack={{limit: 1}} />

                    <div className="general-settings general-settings-new-style" style={{paddingBottom:0,width:'100%'}}>
                        <div className="objects-title objects-title-without-arrow" style={{marginBottom:'30px'}}
                            onClick={() => this.sectionToggle('contractorShow')}
                            >
                            <div style={{display:'flex',alignItems:'center',marginBottom:'6px',marginTop:'10px'}}>
                                <h3 className="create-order__title-toogle" style={{margin:0}}>
                                    <span>Требования к исполнителям</span>
                                    <i className={`title-toggle__arrow ${this.state.contractorShow ? 'active' : ''}`}></i>
                                </h3>
                                <div className="create-order__executor-count">x{currentOrder.contractor_count}</div>
                            </div>
                            <div className="makeorder-section-info">{this.getContractorPreview(currentOrder)}</div>
                        </div>
                        <div
                            style={{width:'calc(100% + 60px)',marginLeft:'-30px',padding:'30px',paddingBottom:'30px',borderRadius:'0 0 20px 20px',background:'#fafafa'}}
                            className={this.state.contractorShow ? "common create-order-accordion active" : "common create-order-accordion"}>
                            
                            <div className="create-order-stars-block" style={{display: 'flex', justifyContent: 'space-between'}}>
                                <div className="field-wrap">
                                    <div className='stars input-wrap width100'>
                                        <div className="form__label" style={{color:'#7b7d86',fontWeight:'bold',fontFamily:'Helvetica',fontSize:'18px'}}>Рейтинг исполнителя</div>
                                        <div style={{display:'flex', flexDirection:'column',marginBottom:'10px'}}>
                                            <ReactStars
                                                edit={false}
                                                className="create-order-star"
                                                count={5}
                                                size={48}
                                                edit={false}
                                                value={currentOrder.contractor_minimal_rating}
                                                half={false}
                                                color1={'#e2e2e2'}
                                                color2={'#faa83d'}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="width60 field-wrap">
                                    <div style={{display:'flex',flexDirection:'row',alignContent: 'center',marginTop:'20px'}}>
                                        <div className="form__label" style={{display: 'flex',marginRight:'5px',fontSize:'15px',justifyContent: 'center',alignItems: 'center',marginBottom:0}}>
                                            Количество исполнителей
                                        </div>
                                        <input
                                            placeholder="Количество исполнителей"
                                            className="width100 person-count-input"
                                            type="number"
                                            value={currentOrder.contractor_count}
                                            readOnly
                                        />
                                    </div>
                                    
                                </div>
                            </div>

                            <div className="autocomplete-wrapper">
                                <input
                                    placeholder="Допустимый радиус съёмки"
                                    className="width100"
                                    type="number"
                                    value={`${currentOrder.order_allow_upload_max_radius} м` || "Не указано"}
                                    readOnly
                                />
                            </div>

                            <div className="autocomplete-wrapper">
                                <input
                                    placeholder="Требования к аппарату"
                                    className="width100"
                                    type="number"
                                    value={currentCamera && currentCamera.title || "Не указано"}
                                    readOnly
                                />
                            </div>
                        </div>
                    </div>

                    <div className="bidding general-settings-new-style" style={{paddingBottom:0,width:'100%'}}>
                        <div
                            className="bidding-title"
                            style={{borderBottom:0,marginBottom:'30px'}}
                            onClick={() => this.sectionToggle('biddingShow')}
                            >
                            <div style={{display:'flex',alignItems:'center',marginBottom:'6px',marginTop:'10px'}}>
                                <h3 className="create-order__title-toogle" style={{margin:0}}>
                                    <span>Подбор и назначение исполнителя</span>
                                    <i className={`title-toggle__arrow ${this.state.biddingShow ? 'active' : ''}`}></i>
                                </h3>
                            </div>
                            <div className="makeorder-section-info">{this.getBidsPreview(currentOrder)}</div>
                        </div>
                        <div
                            style={{width:'calc(100% + 60px)',marginLeft:'-30px',padding:'30px',paddingBottom:'30px',borderRadius:'0 0 20px 20px',background:'#fafafa'}}
                            className={this.state.biddingShow ? "bidding-block active" : "bidding-block"}>
                            <div className="checkboxes without-bidding width100">
                                <label className="c-form__label" htmlFor="without-bidding">
                                    <label className="custom-radio">
                                        <input
                                            type="checkbox"
                                            name="consult"
                                            id="without-bidding"
                                            value={currentOrder.is_auction}
                                            checked={!currentOrder.is_auction}
                                            style={{fontWeight:'bold',color:'#383838'}}
                                            readOnly
                                        />
                                        <div></div>
                                    </label>
                                    <span className="text">Без торгов</span>
                                </label>
                            </div>

                            {
                                currentOrder.is_auction ?
                                <div>
                                    <div className="signature-wrap">
                                        <span className="signature">
                                            Торги начинаются за
                                        </span>
                                        <input
                                            type="text"
                                            value={currentOrder.auction_time}
                                            readOnly
                                        />
                                    </div>

                                    <div style={{fontSize:'12px', marginTop:'15px', color:'#666', borderBottom:'3px solid #e2e2e2',paddingBottom:'20px'}}>
                                        {`Торги начинаются за ${currentOrder.auction_time} мин.`}
                                    </div>

                                    <div className="signature-wrap" style={{width:'100%',borderBottom:'3px solid #e2e2e2',paddingBottom:'20px'}}>
                                        <span className="signature">
                                            Шаг торгов:
                                        </span>
                                        <input
                                            type="text"
                                            value={currentOrder.auction_step}
                                            readOnly
                                        />
                                    </div>
                                </div>
                                : ''
                            }

                            <div className="signature-wrap">
                                <span className="signature">
                                    Назначение исполнителя за:
                                </span>

                                <div className="input-wrap" style={{justifyContent: 'flex-start'}}>
                                    <input
                                        type="text"
                                        value={currentOrder.auction_set_contractor}
                                        readOnly
                                    />
                                </div>
                                
                            </div>
                        </div>
                    </div>

                    <div className="general-settings general-settings-new-style" style={{width:'100%'}}>
                        <div className="field-wrap" style={{marginTop:0,marginBottom:0}}>
                            <div className="textarea-style-container">
                                <Textarea
                                    value={currentOrder.content}
                                    placeholder="Общее примечание к заказу"
                                    className="width100"
                                    readOnly
                                />
                            </div>
                        </div>
                    </div>

                    <div  className="customer-info-wrap">
                        <div className="field-wrap" style={{marginTop:'10px'}}>
                            <div className={"checkboxes checkboxes_align-left"}>
                                <label className="c-form__label" htmlFor="orders_auction">
                                    <label className="custom-radio">
                                        <input
                                            checked={currentOrder.is_public}
                                            className="value"
                                            type="checkbox"
                                            id="orders_auction"
                                            disabled
                                        />
                                        <div></div>
                                    </label>
                                    <span className="text">Согласен на публикацию в общем доступе</span>
                                </label>
                            </div>
                        </div>

                        <div className="field-wrap" style={{marginTop:'10px'}}>
                            <div className={"checkboxes checkboxes_align-left"}>
                                <label className="c-form__label" htmlFor="access_from_web">
                                    <label className="custom-radio">
                                        <input
                                            checked={currentOrder.allow_upload_results_from_web}
                                            className="value"
                                            type="checkbox"
                                            id="access_from_web"
                                            readOnly
                                        />
                                        <div></div>
                                    </label>
                                    <span className="text">Разрешить загрузку результатов с компьютера</span>
                                </label>
                            </div>
                        </div>

                        {
                            currentOrder.is_test
                            ?
                            null
                            :
                            <div className="width100 field-wrap" style={{width: '100%', borderTop: 'solid 1px #e2e2e2',paddingTop:'20px',marginTop:'10px'}}>
                                Заказчик: <Link to={`/profile/${currentOrder.user.id}`}>{`${currentOrder.user.first_name} ${currentOrder.user.last_name}`}</Link>
                            </div>
                        }
                        
                    </div>


                   

                <div className="info-address-and-date-and-price" style={{border: 0, marginTop: 0}}>

                    {
                        is_test ? null
                        :
                        <div className="price-wrap" style={{ justifyContent: 'space-between', width:'100%', padding: '30px 0'}}>
                            <strong className="price">{this.props.price} р.</strong>

                            {
                                changePriceButton && menuCount < 3
                                ?
                                <a href="" onClick={(e) => { changePrice(e) }}>Изменить цену</a>
                                : null
                            }

                            {
                                repeatOrderButton && menuCount < 3
                                ?
                                <a href="" onClick={(e) => { repeatOrder(e) }}>Повторить заказ</a>
                                : null
                            }

                            {
                                quitOrderButton && menuCount < 3
                                ? <a href="" onClick={(e) => this.handleQuitFromOrder(e)}>Отказаться от заказа</a>
                                : null
                            }

                            {
                                responseButton && menuCount < 3
                                ? <a href="" onClick={(e) => {e.preventDefault(); this.handleResponseOrder(currentOrder.id)}}>Откликнуться на заказ</a>
                                : null
                            }

                            {
                                (isCustomer && currentOrder.is_failed) ?
                                <span className="text_red">Заказ отменен</span>
                                :
                                (isCustomer && (currentOrder.status >=1 && currentOrder.status <= 4) && menuCount < 3)
                                ?
                                <div>
                                    <a href="" onClick={(e) => cancelOrder(e)}>Отменить заказ</a>
                                </div>
                                : null
                            }

                            {
                                editOrderButton && menuCount < 3
                                ? 
                                <a href="" onClick={(e) => editOrder(e)}>Редактировать заказ</a>
                                : null
                            }

                            {
                                menuCount > 2 ?
                                <div style={{position:'relative'}} className="order__menu-sprite">
                                    <button onClick={this.showMenu} className="order__menu__button">
                                        Выбрать действие
                                    </button>
                                        
                                    {
                                    this.state.showMenu
                                        ?   <div
                                                className="order__menu__container"
                                                ref={(element) => {
                                                this.dropdownMenu = element;
                                            }}>
                                                {
                                                    changePriceButton ?
                                                    <a className="order__menu__li" href="" onClick={(e) => { changePrice(e) }}>Изменить цену</a>
                                                    : null
                                                }
                                                {
                                                    repeatOrderButton ?
                                                    <a className="order__menu__li" href="" onClick={(e) => { repeatOrder(e) }}>Повторить заказ</a>
                                                    : null
                                                }
                                                {
                                                    quitOrderButton
                                                    ? <a className="order__menu__li" href="" onClick={(e) => this.handleQuitFromOrder(e)}>Отказаться от заказа</a>
                                                    : null
                                                }
                                                {
                                                    responseButton
                                                    ? <a className="order__menu__li" href="" onClick={(e) => this.handleResponseOrder(currentOrder.id)}>Откликнуться на заказ</a>
                                                    : null
                                                }
                                                {
                                                    editOrderButton ?
                                                    <a className="order__menu__li" href="" onClick={(e) => editOrder(e)}>Редактировать заказ</a>
                                                    : null
                                                }
                                                {
                                                    cancelOrderButton ?
                                                    <a className="order__menu__li" href="" onClick={(e) => cancelOrder(e)}>Отменить заказ</a>
                                                    : null
                                                }
                                            </div>
                                        : null
                                    }
                                </div>
                                : null
                            }
                        </div>
                    }
                    </div>

            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};

export default connect(
    mapStateToProps,
)(MakeOrderDatePriceInfo);


// WEBPACK FOOTER //
// ./src/components/MakeOrder/MakeOrderDatePriceInfo.js